const data = [
  {
    id: 'seed',
    label: 'Seed',
    value: 5,
  },
  {
    id: 'private_a',
    label: 'Private A',
    value: 6,
  },
  {
    id: 'private_b',
    label: 'Private B',
    value: 8,
  },
  {
    id: 'public',
    label: 'Public',
    value: 8,
  },
  {
    id: 'liquidity',
    label: 'Liquidity',
    value: 12,
  },
  {
    id: 'treasury',
    label: 'Treasury',
    value: 26,
  },
  {
    id: 'team_and_advisors',
    label: 'Team & Advisors',
    value: 10,
  },
  {
    id: 'development',
    label: 'Development',
    value: 10,
  },
  {
    id: 'marketing',
    label: 'Marketing',
    value: 15,
  },
];

export default data;
